import { render } from "./ValidationOrders.vue?vue&type=template&id=6ea6919e"
import script from "./ValidationOrders.vue?vue&type=script&lang=js"
export * from "./ValidationOrders.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/ValidationOrders.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ea6919e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ea6919e', __exports__)) {
    console.log('reload')
    api.reload('6ea6919e', __exports__)
  }
  
  module.hot.accept("./ValidationOrders.vue?vue&type=template&id=6ea6919e", () => {
    console.log('re-render')
    api.rerender('6ea6919e', render)
  })

}


export default __exports__